import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-floating-icon-button',
  templateUrl: './floating-icon-button.component.html',
  styleUrl: './floating-icon-button.component.scss',
  standalone: false
})
export class FloatingIconButtonComponent {
  @Input() iconClass: string = '';
  @Input() isDisabled: boolean = false;
  @Input() addShadow: boolean = true;

  @Output() onClick = new EventEmitter<void>();

  onClickAction() {
    if (!this.isDisabled) {
      this.onClick.emit();
    }
  }
}
